import { MINUTES_INTERVAL } from "./recently-offline-agents-metric.constants";
import { startOfMinute, subMinutes } from "date-fns";

/**
 * Get the start and end date times for the next request.
 * @returns Start and end date time.
 */
export const getStartDateTime = () => {
    return startOfMinute(subMinutes(new Date(), MINUTES_INTERVAL));
};
